var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAi = function SvgAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 27,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FACD47",
    fillRule: "evenodd",
    d: "M9.665 22.007c-1.338-2.866-4.65-4.426-4.65-9.006a7.985 7.985 0 0 1 15.97 0c0 4.58-3.312 6.14-4.65 9.006v3.118a1.044 1.044 0 0 1-1.04 1.041h-4.589a1.044 1.044 0 0 1-1.04-1.04z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3EBD6",
    d: "M12.612.388a.389.389 0 1 1 .777 0V3.1a.389.389 0 1 1-.777 0zM2.352 19.813a.388.388 0 1 1-.388-.672l2.093-1.207a.387.387 0 1 1 .388.67zM.388 13.602a.388.388 0 1 1 0-.777h2.507a.389.389 0 1 1 0 .777zm5.88-11.278a.387.387 0 0 1 .67-.387L8.28 4.263a.387.387 0 1 1-.67.388zM24.034 19.14a.387.387 0 1 1-.389.672l-2.093-1.21a.387.387 0 1 1 .389-.67zm-.216-12.624a.388.388 0 0 1 .389.672l-2.261 1.305a.387.387 0 0 1-.389-.67z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    fillRule: "evenodd",
    d: "M16.335 22.008v3.118a1.044 1.044 0 0 1-1.041 1.04h-4.588a1.044 1.044 0 0 1-1.04-1.04v-3.118z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M9.665 22.008h6.67v2.058h-6.67z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D2D",
    fillRule: "evenodd",
    d: "M10.962 24.065H9.665v1.06a1.044 1.044 0 0 0 1.041 1.04h1.297a1.043 1.043 0 0 1-1.04-1.04z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D2D",
    d: "M9.665 22.008h1.297v2.058H9.665z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBBE39",
    fillRule: "evenodd",
    d: "M9.665 22.008h1.297c-1.338-2.866-4.65-4.426-4.65-9.006a7.987 7.987 0 0 1 7.336-7.96 7.984 7.984 0 0 0-8.634 7.96c0 4.58 3.313 6.14 4.651 9.006",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCD97",
    d: "m18.5 0 .884 1.616L21 2.5l-1.616.884L18.5 5l-.884-1.616L16 2.5l1.616-.884z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#BB9421",
    d: "M15.33 16.563V10h1.284v6.563zM13.184 16.563 10.672 10h1.284l2.588 6.563zm-5.184 0L10.588 10h1.284l-2.513 6.563zm1.219-1.444v-1.135h4.115v1.135z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFCD97",
    d: "m23.818 11 .643 1.175 1.175.643-1.175.643-.643 1.175-.643-1.175L22 12.818l1.175-.643zM3.364 7l.482.881.881.483-.881.482-.482.881-.483-.881L2 8.364l.881-.483z"
  })));
};
export default SvgAi;